import styled from "styled-components"

export default {
    "TableDiv": styled.div`
        display: flex;
        flex-wrap: wrap;
        border-top: 1px solid ${({ theme }) => theme.color.grey2};
    `,
    "TableElement": styled.div`
        flex-basis: 50%;
        flex-grow: 1;
        display: flex;
        border-bottom: 1px solid ${({ theme }) => theme.color.grey2};

        & > h2 {
            display: flex;
            align-items: center;
            width: 200px;
            min-width: 200px;
            padding: 8px 16px;
            background-color: ${({ theme }) => theme.color.grey1};
            ${({ theme }) => theme.font.extra_small_bold};
        }

        & > p {
            display: flex;
            align-items: center;
            flex-grow: 1;
            ${({ theme }) => theme.font.extra_small};
            padding: 8px 16px;
        }
    `,
    "TableVerticalElement": styled.div`
        width: 100%;
        display: flex;
        border-bottom: 1px solid ${({ theme }) => theme.color.grey2};
        
        & > h2 {
            display: flex;
            align-items: center;
            width: 200px;
            min-width: 200px;
            padding: 8px 16px;
            background-color: ${({ theme }) => theme.color.grey1};
            ${({ theme }) => theme.font.extra_small_bold};
        }

        & > p {
            display: flex;
            align-items: center;
            flex-grow: 1;
            ${({ theme }) => theme.font.extra_small};
            padding: 8px 16px;
        }
    `,
}